module.exports = __webpack_public_path__ + "img/responsive hospitium-05.8072bd28.jpg";